import React from 'react';
import {
  UsersIcon,
  UserGroupIcon,
  MegaphoneIcon,
  EnvelopeIcon,
} from '@heroicons/react/24/outline';

const MarketingStats = ({ members, audiences, campaigns, totalMembers }) => {
  const activeCampaigns = campaigns.filter(c => c.status === 'ACTIVE' || c.status === 'SCHEDULED').length;
  const emailAudiences = audiences.filter(a => a.channel === 'EMAIL').length;

  const stats = [
    {
      name: 'Total Members',
      value: (totalMembers || members.length).toString(),
      change: 'Contacts in database',
      icon: UsersIcon,
      iconColor: 'bg-purple-500',
    },
    {
      name: 'Audiences',
      value: audiences.length.toString(),
      change: `${emailAudiences} email audiences`,
      icon: UserGroupIcon,
      iconColor: 'bg-blue-500',
    },
    {
      name: 'Campaigns',
      value: campaigns.length.toString(),
      change: `${activeCampaigns} active/scheduled`,
      icon: MegaphoneIcon,
      iconColor: 'bg-green-500',
    },
    {
      name: 'Email Channel',
      value: emailAudiences.toString(),
      change: 'Ready for campaigns',
      icon: EnvelopeIcon,
      iconColor: 'bg-orange-500',
    },
  ];

  return (
    <div className="mb-8 overflow-x-auto pb-2">
      <div className="flex gap-4 min-w-max md:grid md:grid-cols-2 lg:grid-cols-4 md:min-w-0">
        {stats.map((stat) => {
          const Icon = stat.icon;
          return (
            <div key={stat.name} className="bg-white overflow-hidden shadow rounded-lg w-48 flex-shrink-0 md:w-auto">
              <div className="p-4 md:p-5">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <div className={`w-10 h-10 ${stat.iconColor} rounded-md flex items-center justify-center`}>
                      <Icon className="w-6 h-6 text-white" aria-hidden="true" />
                    </div>
                  </div>
                  <div className="ml-4 md:ml-5 w-0 flex-1">
                    <dl>
                      <dt className="text-sm font-medium text-gray-500 truncate">{stat.name}</dt>
                      <dd className="text-xl md:text-2xl font-semibold text-gray-900">{stat.value}</dd>
                    </dl>
                  </div>
                </div>
                <div className="mt-2 md:mt-3">
                  <p className="text-xs md:text-sm text-gray-500">{stat.change}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MarketingStats;

